export const AccountType = {
  例外: 0,
  一般: 1,
  特定: 2,
  NISA: 3,
  旧NISA: 4,
  'NISA（つみたて投資枠）': 5,
  'NISA（成長投資枠）': 6,
  iDeCo: 7,
  企業型: 8,
  その他: 9,
} as const;

export const CashMargin = {
  現物: 1,
  信用: 2,
} as const;

export const TradeType = {
  なし: 0,
  新規: 1,
  返済: 2,
  現引: 3,
  現渡: 4,
} as const;

export const Side = {
  売: 1,
  買: 2,
  不明: 0,
} as const;

export const Exchange = {
  東証: 1,
  名証: 2,
  福証: 3,
  札証: 4,
  大証: 5,
  PTS: 6,
  その他: 9,
  NYSE: 11,
  NASDAQ: 12,
  'NYSE Arca': 13,
  'NYSE American': 14,
};

export const BracketType = {
  round: ['(', ')'],
  curly: ['{', '}'],
  square: ['[', ']'],
  angle: ['<', '>'],
  none: ['', ''],
} as const;

export const AssetType = {
  国内現物: 1,
  信用: 2,
  外国株式: 3,
  FX: 4,
  仮想通貨: 5,
  投資信託: 6,
  預金_MRF: 7,
  外国預金_MMF: 8,
  その他: 9,
  ロボアドバイザー: 10,
  未上場株式: 11,
  '国内ETF・ETN': 12,
  '外国ETF・ETN': 13,
  国内REIT: 14,
  外国REIT: 15,
  国内債券: 16,
  外国債券: 17,
  国内EB: 18,
  外国EB: 19,
  不動産: 20,
} as const;

export const expandTypes = {
  close: 0,
  open: 1,
} as const;

export const productTypes = {
  国内株式: 1,
  外国株式: 2,
  投資信託: 3,
  ロボアド: 4,
  預金_MRF: 5,
  未上場株式: 6,
  '国内ETF・ETN': 7,
  '外国ETF・ETN': 8,
  国内REIT: 9,
  外国REIT: 10,
  国内債券: 11,
  外国債券: 12,
  国内EB: 13,
  外国EB: 14,
  不動産: 15,
  // memo: GetPositionsの手入力-信用のみproductType->90となる
  信用: 90,
  その他: 99,
} as const;

// memo: getNotificationsAPIのtypeの採番。お知らせ(notificationList)URLのパラメータとは関連なし。
export const notificationTypes = {
  重要なお知らせ: 0,
  通常お知らせ: 1,
  // 決算情報: 2,
  適時開示: 3,
  レポート: 4,
  経済指標: 5,
  資産形成ガイド: 6,
};

export type BrokerIDs<T> = {
  SBI証券: T;
  楽天証券: T;
  三菱UFJeスマート証券: T;
  松井証券: T;
  みんかぶロボ?: T;
  マネックス証券?: T;
  野村證券?: T;
  大和証券?: T;
  SMBC日興証券?: T;
  岡三証券?: T;
  みずほ証券?: T;
  三菱UFJモルガンスタンレー証券?: T;
  'JIS&T'?: T;
  NRK?: T;
  SBIベネフィットシステムズ?: T;
};

export const TecotecBrokerIds: BrokerIDs<string> = {
  SBI証券: '0100',
  楽天証券: '0200',
  三菱UFJeスマート証券: '0300',
  松井証券: '0400',
  みんかぶロボ: '1100',
};

// memo: 三菱UFJ eスマート証券のMONOBrokerIDは旧社名から変更していない
export const MONOBrokerIds: BrokerIDs<string> = {
  SBI証券: 'SBI',
  楽天証券: 'RAKUTEN',
  三菱UFJeスマート証券: 'AU_KABUCOM',
  松井証券: 'MATSUI',
  マネックス証券: 'MONEX',
  野村證券: 'NOMURA',
  大和証券: 'DAIWA',
  SMBC日興証券: 'NIKKO',
  岡三証券: 'OKASAN',
  みずほ証券: 'MIZUHO',
  三菱UFJモルガンスタンレー証券: 'MUFG_MORGAN_STANLEY',
  'JIS&T': 'JIS_T',
  NRK: 'NRK',
  SBIベネフィットシステムズ: 'SBI_BENEFIT',
};

export const MoneytreeBrokerIds: BrokerIDs<string> = {
  SBI証券: 'sbi_securities',
  楽天証券: 'rakuten_securities',
  三菱UFJeスマート証券: 'kabu_dot_com_securities',
  松井証券: 'matsui_securities',
};

export const ManualBrokerID = {
  手入力口座: 'Manual',
};

export const brokerIDsToArray = <T>(brokerIDs: BrokerIDs<T>): T[] => {
  return [
    [brokerIDs.SBI証券],
    [brokerIDs.三菱UFJeスマート証券],
    brokerIDs.みんかぶロボ ? [brokerIDs.みんかぶロボ] : [],
    [brokerIDs.松井証券],
    [brokerIDs.楽天証券],
    brokerIDs.マネックス証券 ? [brokerIDs.マネックス証券] : [],
    brokerIDs.野村證券 ? [brokerIDs.野村證券] : [],
    brokerIDs.大和証券 ? [brokerIDs.大和証券] : [],
    brokerIDs.SMBC日興証券 ? [brokerIDs.SMBC日興証券] : [],
    brokerIDs.岡三証券 ? [brokerIDs.岡三証券] : [],
    brokerIDs.みずほ証券 ? [brokerIDs.みずほ証券] : [],
    brokerIDs.三菱UFJモルガンスタンレー証券
      ? [brokerIDs.三菱UFJモルガンスタンレー証券]
      : [],
    brokerIDs['JIS&T'] ? [brokerIDs['JIS&T']] : [],
    brokerIDs.NRK ? [brokerIDs.NRK] : [],
    brokerIDs.SBIベネフィットシステムズ
      ? [brokerIDs.SBIベネフィットシステムズ]
      : [],
  ].flat();
};

export const BrokerIDss: BrokerIDs<string[]> = Object.fromEntries(
  Object.keys(MONOBrokerIds).map(k => {
    const extract = <T extends { [key: string]: unknown }>(
      key: string,
      obj: T
    ) => {
      const value =
        typeof obj === 'object' && obj && key in obj ? obj[key] : null;
      return value ? [value] : [];
    };
    return [
      k,
      [
        extract(k, TecotecBrokerIds),
        extract(k, MONOBrokerIds),
        extract(k, MoneytreeBrokerIds),
      ].flat(),
    ];
  })
) as BrokerIDs<string[]>;

export const ChartPeriodTypes = {
  直近: 0,
  日: 1,
  週: 2,
  月: 3,
  年: 4,
} as const;

export const AggregateSourceTypes = {
  テコテック: 1,
  マネーツリー: 2,
  MONO: 3,
  手入力: 99,
} as const;

export const HeaderActionType = {
  追加: 1,
  編集: 2,
  削除: 3,
  配当金: 4,
  更新: 5,
} as const;

export const HeaderActionPatternType = {
  なし: 0,
  編集_削除_1つ: 1,
  編集_削除_それぞれ: 2,
  更新_削除_それぞれ: 3,
} as const;

export const roboType = {
  minkabu: '1100',
  wealthnabi: 'wealthnabi',
  theo: 'theo',
} as const;

export const BrokerType = {
  証券: 1,
  銀行: 2,
  クレジットカード: 3,
  電子マネー: 4,
  ポイント: 5,
  確定拠出年金: 7,
  不明: 99,
} as const;

export const TransactionsCategoryType = {
  車: 'auto',
  買い物: 'shopping',
  子供: 'children',
  投資: 'investments',
  返済: 'debt_repayment',
  通信: 'communications',
  外食: 'eating_out',
  教育: 'education',
  手数料: 'fees',
  食費: 'groceries',
  '医療・健康': 'health_medical',
  住宅: 'home',
  レジャー: 'holiday_leisure',
  メディア: 'media',
  交際費: 'entertainment',
  税金: 'taxes',
  交通: 'transport',
  水道光熱費: 'utilities',
  贈り物: 'gifts_donations',
  パーソナルケア: 'personal_care',
  営業費: 'business_expense',
  給料: 'salary',
  収入: 'other_income',
  振替: 'transfer',
  未定: 'uncategorized',
  金融サービス: 'financial_services',
} as const;

export const CURRENCY = {
  米ドル: 'USD',
  ユーロ: 'EUR',
  英ポンド: 'GBP',
  オーストラリアドル: 'AUD',
  トルコリラ: 'TRY',
  ランド: 'ZAR',
  ニュージーランドドル: 'NZD',
  ブラジルレアル: 'BRL',
  カナダドル: 'CAD',
  スイスフラン: 'CHF',
  シンガポールドル: 'SGD',
  香港ドル: 'HKD',
  中国人民元: 'CNY',
  韓国ウォン: 'KRW',
  タイバーツ: 'THB',
  マレーシアリンギット: 'MYR',
  インドネシアルピア: 'IDR',
  フィリピンペソ: 'PHP',
  ベトナムドン: 'VND',
  新台湾ドル: 'TWD',
  メキシコペソ: 'MXN',
  ロシアルーブル: 'RUB',
  インドルピー: 'INR',
  スウェーデンクローナ: 'SEK',
  ノルウェークローネ: 'NOK',
  デンマーククローネ: 'DKK',
  ポーランドズロチ: 'PLN',
} as const;

export type Currency = typeof CURRENCY[keyof typeof CURRENCY];

export const SNSTypes = {
  twitter: 1,
} as const;

export type SNSType = typeof SNSTypes[keyof typeof SNSTypes];

export const reportType = {
  日次: 1,
  週次: 2,
  月次: 3,
  年次: 4,
};

export const InvestorRegistrationResultCode = {
  正常終了: 0,
  メールアドレス重複: 1,
  異常終了: 2,
};

export const NotificationCode = {
  お知らせ: 0,
  LP: 1,
  投稿: 2,
};
